import { createServerFn } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';
import { auth } from '@app/auth';

export const getServerSession = createServerFn({ method: 'GET' }).handler(
  async () => {
    const request = getRequest();
    try {
      const session = await auth.api.getSession({
        headers: request.headers,
      });
      return session;
    } catch (err) {
      // Session resolution can throw for transient reasons — a stale session
      // cookie signed with a rotated JWKS key, BETTER_AUTH_SECRET rotation,
      // DB connection blips. Treat these as "not authenticated" rather than
      // crashing the route. Users with bad cookies can hit /auth/recover to
      // clear them.
      console.warn('[auth] getSession failed, treating as unauthenticated:', err instanceof Error ? err.message : err);
      return null;
    }
  },
);
